import { c as _c } from "react/compiler-runtime";
import { useAnalyticsTags } from '@libs/analytics';
import { useOptimizely } from '@libs/common-next';
import type { AssistedSearchState } from '../search.types';
import { trackApplicationSubmit as trackApplicationSubmitEffects } from './track-application-submit';
type TrackApplicationSubmitOptions = {
  assistedSearch: AssistedSearchState;
  query: string;
};
export function useSearchAnalytics() {
  const $ = _c(6);
  const {
    context: optimizelyContext
  } = useOptimizely();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["autocomplete"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentAnalyticsTags = useAnalyticsTags(t0);
  let t1;
  if ($[1] !== optimizelyContext) {
    t1 = t2 => {
      const {
        assistedSearch,
        query
      } = t2;
      trackApplicationSubmitEffects({
        assistedSearch,
        query,
        trackOptimizelySearch: optimizelyContext ? () => optimizelyContext.trackEvent("user_search") : undefined
      });
    };
    $[1] = optimizelyContext;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trackApplicationSubmit = t1;
  let t2;
  if ($[3] !== currentAnalyticsTags || $[4] !== trackApplicationSubmit) {
    t2 = {
      currentAnalyticsTags,
      trackApplicationSubmit
    };
    $[3] = currentAnalyticsTags;
    $[4] = trackApplicationSubmit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}